export default [
  {
    path: '/invoice-confirm',
    name: 'invoice-confirm',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice-confirm/index.vue')
  },
  {
    path: '/invoice-confirm/scanners',
    name: 'invoice-confirm-scanner',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice-confirm/scanner.vue')
  }
]